(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifMessages', swifMessages);


    function ErrorController($scope, $uibModal, errorMsgService, $location, userService, settingsService){
        'ngInject';
        $scope.errors = errorMsgService.getErrors();
        $scope.closeError = function (index){
            errorMsgService.closeError(index);
        };
        $scope.sendAlert = function (alert) {
            alert._send = true;
        };
        var modal = {};
        function clearErrors() {
            errorMsgService.clearErrors();
            delete modal.instance;
        }
        $scope.$watch('errors', function (newV) {
            if (_.isEmpty(newV)) {
                return;
            }
            if (!modal.instance) {
                modal.instance = $uibModal.open({
                    templateUrl: 'partials/framework/modal.html',
                    controller: 'ModalController',
                    resolve: {
                        modalParams: function () {
                            return {
                                title: 'An error occured',
                                templateUrl: 'partials/ui/messages.html',
                                model: $scope.errors,
                                action: {
                                    btn: {'class': 'btn-danger', title: 'Close'}
                                },
                                user: userService,
                                $location: $location,
                                settings: settingsService
                            };
                        }
                    }
                });
                modal.instance.result.then(clearErrors, clearErrors);
            }
        }, true);
    }

    /**
     * @ngdoc directive
     * @name swif.ui:swifMessages
     * @module swif.ui
     * @restrict E
     * @description display error messages to the user using modals
    **/
    function swifMessages() {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controller: ErrorController
        };
    }

})();
